import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { useSaleSoDetailModel } from "./saleSoDetailModel";
import { formatNum } from "@/utils/utils";
import { RouterParamType } from "@/model/navModel";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { addDesc, editDesc, lookDesc } = useSaleSoDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: "销售项数",
            value: formatNum(typeDesc[mode]?.itemNumAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "销售数量",
            value: formatNum(typeDesc[mode].numAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "销售总金额",
            value: formatNum(typeDesc[mode].totalAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "优惠总金额",
            value: formatNum(typeDesc[mode].discountAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "应收金额",
            value: formatNum(typeDesc[mode].receivableAll),
            color: DescriptionColorEnum.red,
            status: true
        },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}